import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useState } from "react";
import { SignUpModalSSOOrEmailForm } from "~/components/Modals/SignupModal/SignUpModalSSOOrEmailForm";
import { SignUpModalUserDetailsForm } from "~/components/Modals/SignupModal/SignUpModalUserDetailsForm";
export const SignUpModalForm = /*#__PURE__*/ memo((param)=>{
    let { accountCreationSource, onSuccess, onLoginClick, ssoCallbackData, closeModal } = param;
    const [submittedEmail, setSubmittedEmail] = useState();
    if (submittedEmail) {
        return /*#__PURE__*/ _jsx(SignUpModalUserDetailsForm, {
            email: submittedEmail,
            accountCreationSource: accountCreationSource,
            onSuccess: onSuccess,
            onBackClick: ()=>setSubmittedEmail(undefined)
        });
    } else {
        return /*#__PURE__*/ _jsx(SignUpModalSSOOrEmailForm, {
            onLoginClick: onLoginClick,
            closeModal: closeModal,
            onEmailSubmit: setSubmittedEmail,
            accountCreationSource: accountCreationSource,
            ssoCallbackData: ssoCallbackData
        });
    }
});
SignUpModalForm.displayName = "SignUpModalForm";
